<section class="cta-section">

    <div class="container-redesign">

        <div class="cta-section__content">

            <h2 class="cta-section__title">
                Trusted by healthcare teams operating
                in <span>regulated environments</span>
            </h2>

            <p class="cta-section__description">
                Hospitals, mental health clinics, and care organizations rely on AltheaCare to improve
                patient safety, reduce manual monitoring, and act earlier on critical mental health risks.
                The platform is built for regulated healthcare workflows, support coordination
                across clinical teams, and enable confident decision-making in daily mental health
                operations.
            </p>

            <p class="cta-section__description">
                AltheaCare helps institutions move beyond fragmented, reactive care toward a more
                predictive, coordinated, and preventive model of mental healthcare.
            </p>

            <a
                routerLink="/contact-redesign"
                class="cta-section__button">

                <span>TALK TO OUR TEAM</span>

                <img
                    src="/assets/img/redesign/flecha.svg"
                    alt=""
                    class="cta-section__button-icon">

            </a>

        </div>

    </div>

</section>